module.exports = __webpack_public_path__ + "img/download.4a641988.svg";